import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = '/produtos';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="app-error-fallback">
          <div className="text-center space-y-4 max-w-sm">
            <p className="text-white font-bold text-xl gaming-title">OPS, ALGO DEU ERRADO</p>
            <p className="text-gray-400 text-sm">Tente recarregar a pagina. Se o problema continuar, chame nosso suporte.</p>
            <button
              onClick={this.handleReload}
              className="bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-3 rounded-xl gaming-title"
              data-testid="app-error-reload-btn"
            >
              RECARREGAR
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
